import React from "react";
import { Link } from "react-router-dom";
import { Gauge, Calendar, Fuel, Settings } from "lucide-react";
import { buildFileUrl, formatEuro, formatKm, whatsappLink } from "@/api";

const badgeClass = (b) => {
  const v = (b || "").toLowerCase();
  if (v.includes("arrivo")) return "badge-in-arrivo";
  if (v.includes("vendut")) return "badge-venduta";
  return "badge-disponibile";
};

export const VehicleCard = ({ v }) => {
  const img = v.galleria?.[0] ? buildFileUrl(v.galleria[0]) : "";
  return (
    <Link to={`/veicolo/${v.id}`} className="card-vehicle rounded-lg overflow-hidden group block cursor-pointer" data-testid="vehicle-card">
      <div className="relative aspect-[16/10] overflow-hidden bg-[#1A1A1E]">
        {img && (
          <img src={img} alt={v.titolo} className="w-full h-full object-cover group-hover:scale-105 transition duration-500" />
        )}
        <div className={`absolute top-3 left-3 px-2.5 py-1 rounded-sm text-[10px] font-bold tracking-widest uppercase ${badgeClass(v.badge)}`} data-testid="vehicle-badge">
          {v.badge}
        </div>
        <div className="absolute bottom-3 right-3 bg-[#0B0B0C]/85 backdrop-blur-sm border border-[#E1BC56]/40 px-3 py-1 rounded-sm">
          <span className="font-display font-bold text-[#E1BC56] tracking-wider">{formatEuro(v.prezzo)}</span>
        </div>
      </div>
      <div className="p-5">
        <div className="text-xs text-zinc-500 tracking-widest uppercase mb-1">{v.marca}</div>
        <h3 className="font-display text-lg font-bold text-white tracking-wider uppercase mb-4 line-clamp-1 group-hover:text-[#E1BC56] transition">{v.titolo}</h3>
        <div className="grid grid-cols-2 gap-2.5 text-xs text-zinc-400 mb-5">
          <div className="flex items-center gap-1.5"><Calendar className="w-3.5 h-3.5 text-[#A3802C]" /> {v.anno}</div>
          <div className="flex items-center gap-1.5"><Gauge className="w-3.5 h-3.5 text-[#A3802C]" /> {formatKm(v.km)}</div>
          <div className="flex items-center gap-1.5"><Fuel className="w-3.5 h-3.5 text-[#A3802C]" /> {v.alimentazione}</div>
          <div className="flex items-center gap-1.5"><Settings className="w-3.5 h-3.5 text-[#A3802C]" /> {v.cambio}</div>
        </div>
        <div className="flex gap-2">
          <span className="flex-1 cmc-btn-outline text-xs px-3 py-2 rounded-sm text-center" data-testid="vehicle-detail-btn">Dettagli</span>
          <a href={whatsappLink(`Ciao LC Auto, vorrei informazioni sulla ${v.titolo}`)} target="_blank" rel="noreferrer"
            onClick={(e) => e.stopPropagation()}
            className="flex-1 cmc-btn-gold text-xs px-3 py-2 rounded-sm text-center" data-testid="vehicle-whatsapp-btn">WhatsApp</a>
        </div>
        <div className="mt-3 text-[10px] text-center tracking-widest uppercase text-[#E1BC56]/80 font-display">
          Finanziamenti personalizzati disponibili
        </div>
      </div>
    </Link>
  );
};
